import React, { useState } from 'react';
import { 
  Card, 
  Input, 
  Button, 
  message, 
  Tag,
  Space,
  // DatePicker,
  // Modal
} from 'antd';
import { 
  SaveOutlined, 
  TagOutlined,
  CalendarOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { TextArea } = Input;
// const { RangePicker } = DatePicker;

const WritePost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  // 保存文章
  const handleSave = () => {
    if (!title.trim()) {
      message.warning('请输入标题');
      return;
    }
    if (!content.trim()) {
      message.warning('请输入内容');
      return;
    }

    setLoading(true);
    
    // 获取现有文章
    const existingPosts = JSON.parse(localStorage.getItem('myBlogPosts') || '[]');
    
    // 创建新文章
    const newPost = {
      id: Date.now(),
      title,
      content,
      tags,
      date: new Date().toISOString(),
      createdAt: new Date().toLocaleDateString('zh-CN'),
      updatedAt: new Date().toLocaleDateString('zh-CN')
    };

    // 保存到本地存储
    const updatedPosts = [newPost, ...existingPosts];
    localStorage.setItem('myBlogPosts', JSON.stringify(updatedPosts));
    
    setTimeout(() => {
      setLoading(false);
      message.success('文章保存成功！');
      
      // 重置表单
      setTitle('');
      setContent('');
      setTags([]);
      setTagInput('');
      
      // 跳转到归档页面
      navigate('/archive');
    }, 800);
  };

  // 添加标签
  const handleAddTag = () => {
    if (tagInput && !tags.includes(tagInput)) {
      setTags([...tags, tagInput]);
      setTagInput('');
    }
  };

  // 删除标签
  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  // 标签输入框回车事件
  const handleTagKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddTag();
    }
  };

  return (
    <div className="write-post-container">
      <Card 
        className="write-post-card"
        title={
          <div className="post-header">
            <h2>写日记</h2>
            <span className="post-date">
              <CalendarOutlined />
              {new Date().toLocaleDateString('zh-CN')}
            </span>
          </div>
        }
        extra={
          <Space>
            <Button 
              onClick={() => setIsPreview(!isPreview)}
            >
              {isPreview ? '继续编辑' : '预览'}
            </Button>
            <Button 
              type="primary" 
              icon={<SaveOutlined />}
              onClick={handleSave}
              loading={loading}
            >
              保存日记
            </Button>
          </Space>
        }
      >
        {/* 标题输入 */}
        <div className="form-section">
          <Input
            placeholder="今天发生了什么？"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="title-input"
            size="large"
            maxLength={50}
          />
        </div>

        {/* 标签输入 */}
        <div className="form-section">
          <div className="tags-input-container">
            <Input
              placeholder="添加标签（按回车确认）"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyPress={handleTagKeyPress}
              prefix={<TagOutlined />}
              className="tag-input"
            />
            <Button 
              onClick={handleAddTag}
              type="primary"
              size="small"
            >
              添加
            </Button>
          </div>
          <div className="tags-display">
            {tags.map(tag => (
              <Tag 
                key={tag} 
                closable 
                onClose={() => handleRemoveTag(tag)}
                className="post-tag"
              >
                {tag}
              </Tag>
            ))}
          </div>
        </div>

        {/* 内容输入/预览 */}
        <div className="form-section">
          {isPreview ? (
            <Card className="preview-card">
              <h3>{title || '无标题'}</h3>
              <div className="preview-content">
                {content.split('\n').map((line, index) => (
                  <p key={index}>{line || <br />}</p>
                ))}
              </div>
              {tags.length > 0 && (
                <div className="preview-tags">
                  {tags.map(tag => (
                    <Tag key={tag} className="preview-tag">{tag}</Tag>
                  ))}
                </div>
              )}
            </Card>
          ) : (
            <TextArea
              placeholder="记录你的想法和感受..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={12}
              className="content-textarea"
              maxLength={5000}
              showCount
            />
          )}
        </div>

        {/* 提示信息 */}
        <div className="hint-section">
          <p>💡 提示：所有日记都会保存在你的浏览器中，除非主动删除</p>
        </div>
      </Card>
    </div>
  );
};

export default WritePost;